import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { logout } from '../../redux/modules/auth/auth-middleware';
import { acceptTou } from '../../redux/modules/user-profile/user-profile-middleware';
import { setIsDedicatedWorkflow } from '../../redux/modules/workflow/workflow-action-creator';
import { messages } from './TermsOfUsePage.i18n';
import Message from '../../containers/Message/Message';

import AcceptTouForm from '../../containers/Login/AcceptTouForm';

class TermsOfUsePage extends Component {
  constructor(props) {
    super(props);
    this.title = null;
  }

  UNSAFE_componentWillMount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(true));
  };

  componentDidMount = () => {
    this.title.focus();
  };

  componentWillUnmount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
  };

  setTitle = (h1) => {
    this.title = h1;
  };

  handleCancelTou = () => {
    this.props.dispatch(logout());
  };

  handleAcceptTou = () => {
    this.props.dispatch(acceptTou(this.props.userId));
  };

  render() {
    return (
      <div className="col-xs-12">
        <Message />
        <div className="row justify-content-md-center mt-3">
          <div className="col-md-8">
            <h1 id="content" ref={this.setTitle}>
              <span className="title" data-qa-item="touPageTitle">
                <FormattedMessage {...messages.page.title} />
              </span>
            </h1>
            <AcceptTouForm handleCancel={this.handleCancelTou} handleAcceptTou={this.handleAcceptTou} />
          </div>
        </div>
      </div>
    );
  }
}

TermsOfUsePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object,
  patientId: PropTypes.string,
  userId: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
  userId: state.profile.user.userId,
  patientId: state.profile.patient.patientId,
  location: ownProps.location,
});

export default connect(mapStateToProps)(TermsOfUsePage);